import { gql } from "@apollo/client";

export const GET_MASTER_DATA_PRODUCT_PRICE_HISTORY = gql`
  query MasterDataProductPriceHistory(
    $params: MasterDataProductPriceHistoryParamsInput!
  ) {
    masterDataProductPriceHistory(params: $params) {
      product {
        productId
        productKey
        itemName
        upcItemNumber
        categoryName
      }
      purchaserId
      period
      periodStart
      periodEnd
      summary {
        productPrice
        effectiveFrom
        nextScheduledDate
        nextScheduledPrice
        inheritedFromBase
        appliesTo
      }
      items {
        productPriceId
        effectiveFrom
        effectiveTo
        purchaserId
        appliesTo
        oldPrice
        productPrice
        notes
        changedBy
      }
    }
  }
`;
